import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { fetchBillingEntries } from "../api/billingApi";

export const useBillingEntries = ({ dateFrom, dateTo, marketplaceId }) => {
  const { authToken } = useAuth();
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadBilling = useCallback(async () => {
    if (!authToken) {
      setRows([]);
      setCount(0);
      setBalance(0);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await fetchBillingEntries({
        authToken,
        filters: { dateFrom, dateTo, marketplaceId },
      });
      setRows(data.rows);
      setCount(data.count);
      setBalance(data.balance);
    } catch (err) {
      setError(err.message || "An error occurred while fetching billing data.");
      setRows([]);
      setCount(0);
      setBalance(0);
    } finally {
      setLoading(false);
    }
  }, [authToken, dateFrom, dateTo, marketplaceId]);

  useEffect(() => {
    loadBilling();
  }, [loadBilling]);

  return {
    rows,
    count,
    balance,
    loading,
    error,
    reload: loadBilling,
  };
};
